






































import { Component, Prop, Vue } from "vue-property-decorator";
import { FeedEntry } from "@/store/feed";
import QueueButton from "@/components/QueueButton.vue";
import LinkIcon from "bootstrap-icons/icons/box-arrow-up-right.svg";
import RelativeTime from "@/components/RelativeTime.vue";

@Component({
  components: {
    LinkIcon,
    QueueButton,
    RelativeTime
  }
})
export default class FeedCard extends Vue {
  @Prop() entry!: FeedEntry;
}
